/**
 * Варианты осуществления замен при сборке заказа
 */
export enum ReplacementStrategyVariants {
  /**
   * Не спрашивать, убрать из заказа
   */
  SILENT_DROP_ON_MISSING = 0,
  /**
   * Не спрашивать, подобрать аналоги
   */
  SILENT_CHOOSE_SIMILAR = 1,
  /**
   * Позвонить, если что-то отсутствует
   */
  CALL_ON_MISSING = 2,
  /**
   * Позвонить, для согласования замены и подбора аналога
   */
  CALL_CHOOSE_SIMILAR = 3
}